<template>
  <component
    is="{{cpName}}"
    pageConfig="{{pageConfig}}"
    info="{{info}}"
  />
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { props as properties } from './model/props'
import store from '../../lib/store'
import { setOmegaAttrs, xenv } from '@didi/webx-js'

createComponent({
  properties: properties,
  data: {
    cpName: '',
  },
  computed: {
    ...store.mapGetters([ 'initData' ]),
    isLaunchAppH5() {
      if (__mpx_mode__ !== 'web') {
        return false
      }
      return this.initData.activity_info?.is_for_app_download && xenv() !== 'passenger'
    },
  },
  attached() {
    const cpNameMap = {
      sign_in: 'index-sign',
    }
    if (process.env.MODE === 'editor') {
      const pageConfigs = [ 'index', 'resultB', 'result', 'signVersion.index', 'launchApp.index' ]
      pageConfigs.forEach(config => {
        this.$watch(`pageConfig.${config}.show`, {
          handler: function(val) {
            if (val) {
              if (config === 'signVersion.index') {
                this.cpName = cpNameMap.sign_in
              } else if (config === 'launchApp.index') {
                this.cpName = 'launch-app'
              } else {
                this.cpName = 'index-common'
              }
            }
          },
          immediate: true,
        })
      })
      return
    }
    setOmegaAttrs({ fe_style_version: this.initData.activity_info?.fe_style_version })
    if (this.isLaunchAppH5) {
      this.cpName = 'launch-app'
    } else {
      this.cpName = cpNameMap[this.initData.activity_info?.fe_style_version] || 'index-common'
    }
  },
})
</script>


<script name="json">
const config = {
  "component": true,
  "usingComponents": {
    "index-common": "./index-common.mpx",
    "index-sign": "./index-sign.mpx",
  }
}
if (__mpx_mode__ === 'web') {
  config.usingComponents['launch-app'] = './index-app.mpx'
}
module.exports = config
</script>
